// safetyConstruction
/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const safetyConstruction = {
  path: '/safety-construction',
  component: Layout,
  redirect: '/safety-construction/dust-noise',
  name: 'SafetyConstruction',
  meta: {
    title: 'safetyConstruction',
    icon: 'tubiao-zhuzhuangtu',
    perm: 'safetyConstructionManager'
  },
  children: [
    {
      path: 'dust-noise',
      component: () =>
        import('@/views/safety-construction/dust-noise/index.vue'),
      name: 'DustNoise',
      meta: { title: 'dustNoise', perm: 'cSiteYcjzManager' }
    },
    {
      path: 'tower-crane',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'TowerCrane',
      meta: { title: 'towerCrane', perm: 'cSiteCraneManager' },
      children: [
        {
          path: 'tower-crane-device',
          component: () => import('@/views/device/tower-crane/towerCrane.vue'),
          name: 'TowerCraneDevice',
          meta: { title: 'towerCraneDevice', perm: 'cSiteCraneManager' }
        },
        {
          path: 'face-recognition-crane',
          component: () => import('@/views/device/face-recognition/index.vue'),
          name: 'FaceRecognition',
          meta: {
            title: 'faceRecognition',
            deviceType: '7',
            deviceBindingType: 'CRANE'
          }
        },
        {
          path: 'tower-crane-driver',
          component: () =>
            import('@/views/safety-construction/tower-crane/drivers/index.vue'),
          name: 'TowerCraneDriver',
          meta: {
            title: 'towerCraneDriver',
            selectType: '1'
            // perm: 'cSiteVerifyDeviceManager'
          }
        },
        {
          path: 'data-recording-crane',
          component: () =>
            import('@/views/safety-construction/tower-crane/index.vue'),
          name: 'TowerCraneDevice',
          meta: { title: 'dataRecording', perm: 'cSiteCraneManager' }
        }
      ]
    },

    {
      path: 'lift',
      component: () => import('@/layout/ComponentWrap.vue'),
      name: 'Lift',
      meta: { title: 'lift', perm: 'cSiteElevatorDeviceManager' },
      children: [
        {
          path: 'lift-device',
          component: () => import('@/views/device/lift/lift.vue'),
          name: 'LiftDevice',
          meta: {
            title: 'liftDevice',
            perm: 'cSiteElevatorDeviceManager'
          }
        },
        {
          path: 'face-recognition-lift',
          component: () => import('@/views/device/face-recognition/index.vue'),
          name: 'FaceRecognition',
          meta: {
            title: 'faceRecognition',
            deviceType: '7',
            deviceBindingType: 'ELEVATOR'
          }
        },
        {
          path: 'lift-driver',
          component: () =>
            import('@/views/safety-construction/tower-crane/drivers/index.vue'),
          name: 'LiftDriver',
          meta: {
            title: 'liftDriver',
            selectType: '2'
            // perm: 'cSiteVerifyDeviceManager'
          }
        },
        {
          path: 'data-recording-lift',
          component: () => import('@/views/safety-construction/lift/index.vue'),
          name: 'TowerCraneDevice',
          meta: { title: 'dataRecording', perm: 'cSiteCraneManager' }
        }
      ]
    },
    {
      path: 'distribution-box',
      component: () => import('@/views/device/distribution-box/index.vue'),
      name: 'DistributionBox',
      meta: { title: 'distributionBox', perm: 'cSiteAepDeviceManager' }
    }
  ]
}
export default safetyConstruction
